
import React from 'react';
import { useAuth } from '@/context/SupabaseAuthContext';
import { useUserPoints } from '@/hooks/useUserPoints';
import PointRedemptionContent from './PointRedemptionContent';
import UserLayout from '@/components/layouts/UserLayout';

const PointRedemptionPage: React.FC = () => {
  const { user } = useAuth();
  const { points: availablePoints, isLoading } = useUserPoints(user?.id);
  
  return (
    <UserLayout>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6">Point Redemption</h1>
        
        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : (
          <PointRedemptionContent 
            userId={user?.id || ''} 
            availablePoints={availablePoints}
          />
        )}
      </div>
    </UserLayout>
  );
};

export default PointRedemptionPage;
